import { Component, Inject } from '@angular/core';
import { NgForm } from '@angular/forms';
import { DateAdapter } from '@angular/material/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { FirestoreService } from 'src/app/shared/services/firestore.service';
import { UxserviceService } from 'src/app/shared/services/uxservice.service';
// import { ImagecropperComponent } from '../imagecropper/imagecropper.component';

@Component({
  selector: 'app-editprofile',
  templateUrl: './editprofile.component.html',
  styleUrls: ['./editprofile.component.scss']
})
export class EditprofileComponent {
  selectedYear: number;
  years: number[] = [];
  cropperopened:boolean=false;
  userimageCrop: any = "";
  companyimageCrop: any = "";
  imageCrop: any = "";


  userimageplaceholder: any = "";
  companyimageplaceholder: any = "";

  isSubmitting = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dateAdapter: DateAdapter<Date>,
    public dialogRef: MatDialogRef<EditprofileComponent>,
    public dialog: MatDialog,
  private UXService:UxserviceService,
  private firestoreService: FirestoreService,
) {
      this.dateAdapter.setLocale('en-GB');
      this.selectedYear = new Date().getFullYear();
      for (let year = this.selectedYear; year >= 1800; year--) {
        this.years.push(year);
      }
  }
  userinfo: any
  companyname: any
  companyaddress: any
  companycity: any
  companystate: any
  companypostcode: any
  companyphonennumber: any
  companylogo: any
  projectname: any
  projectlocation: any
  projectdescriprtion: any
  projectbudget: any
  serviceprovided: any
  projectarea: any

  ngOnInit(): void {
    console.log(this.data.userdetails);
    console.log(this.data);

    if(this.data.userdetails){
      this.userinfo= Object.assign({},this.data.userdetails)


      if (this.userinfo?.accountdetails?.companylogimage) {
  
        this.companyimageCrop = this.userinfo.accountdetails?.companylogimage
        this.companyimageplaceholder = "";
      } else {
  
        this.companyimageplaceholder = "./../../../../assets/avatar.png";
        this.companyimageCrop = "";
      }
  
      if (this.userinfo?.photoURL) {
    
        this.userimageCrop= this.userinfo.photoURL;
        this.userimageplaceholder = "";
        console.log(this.userimageCrop);
        
      } else {
  
        this.userimageplaceholder = "./../../../../assets/avatar.png";
        this.userimageCrop = "";
      }

    }



  }


  saveEditdetails(reqform:NgForm) {

    if (reqform.invalid) {
      Object.keys(reqform.form.controls).forEach((key) => {
        reqform.form.get(key)?.markAsDirty(); //mark dirty if fields are empty
      });
      console.log("notsave");
      
    }
else {
    this.dialogRef.close(this.userinfo)
}
  }
  canceledit() {
    this.dialogRef.close(false)
  }


//   showCustomCropperDialog(from:any) {
//     console.log(this.userinfo);
    
//     console.log(this.cropperopened);
    
//     this.cropperopened=true
//    console.log("sshbss");
// console.log(this.companyimageCrop);

//     const dialogRef = this.dialog.open(ImagecropperComponent,
//     //   {
//     //     data: {
//     //       height: 200,
//     //       width: 200,
//     //       shape: true,
//     //       placeholder: "./../../../assets/avatar.png",
//     //       image: from === 'userprofile' ? this.userimageCrop : this.companyimageCrop,
//     //       heading: "Update Profile",

//     //       currentuid: this.userinfo.id,
//     //       bucketName: this.userinfo.id,
//     //       bucketFolder: from
//     //     },
//     //     width: "650px",
//     //     maxWidth: "80vw",
//     //     disableClose: true,
//     //     panelClass: 'docdetail'

//     //   });
//     dialogRef.afterClosed().subscribe((res) => {


//       if (res) {
// if(from=='userprofile'){
//   this.updateImageUrl(res);

// }
// if(from=='companyprofile'){
//   this.updatecompanyImageUrl(res)
// }
//       }
//       else{
//         this.cropperopened=false;
//       }
//     })
//   }

  async updateImageUrl(url: string) {
  
  
  
    if (url == "delete") {
      this.userinfo.photoURL = "";

      this.data.userdetails.photoURL = "";
      this.userimageplaceholder = "./../../../../assets/testimgs/avatar.png";
      this.userimageCrop = "";
    } else {
      this.userinfo.photoURL = url;
      this.data.userdetails.photoURL = url;

      this.userimageplaceholder = "";
      this.userimageCrop = url;
    }


    this.UXService.showOverlay('Rendering photo');
    try {
      await this.firestoreService.updateAuthDetailsImg(url).then(async (res) => {
        await this.firestoreService.updateDocumentWithIDOF(`users-list`, this.userinfo.id,
          {
            photoURL: this.userinfo.photoURL
          });
        this.UXService.instantCloseOverlay();
        this.UXService.openSnackBar('Image updated !', 'OK');
        this.isSubmitting = false;
      })

    } catch (e: any) {
      this.UXService.instantCloseOverlay();
      this.UXService.openSnackBar(e, 'OK');
      this.isSubmitting = false;
    }
    this.cropperopened=false;

  }


  async updatecompanyImageUrl(url: string) {



    if (url == "delete") {
      this.userinfo.accountdetails.companylogimage = "";
      this.data.userinfo.accountdetails.photoURL = "";

      this.companyimageplaceholder = "./../../../../assets/avatar.png";
      this.companyimageCrop = "";
    } else {
      this.userinfo.accountdetails.companylogimage = url;
      this.data.userinfo.accountdetails.photoURL = url;

      this.companyimageplaceholder = "";
      this.companyimageCrop = url;
    }
  
  
    this.UXService.showOverlay('Rendering photo');
    try {
      // await this.firestoreService.updateAuthDetailsImg(url).then(async (res) => {
        await this.firestoreService.updateDocumentWithIDOF(`users-list`, this.userinfo.id,this.userinfo )
          // {
          //   companylogimage: this.userObj.accountdetails.companylogimage
          // });
        this.UXService.instantCloseOverlay();
        this.UXService.openSnackBar('Image updated !', 'OK');
        this.isSubmitting = false;
      // })
  
    } catch (e: any) {
      this.UXService.instantCloseOverlay();
      this.UXService.openSnackBar(e, 'OK');
      this.isSubmitting = false;
    }
    this.cropperopened=false;
  
  }
  
}
